import { ActivityLogParser } from '@/parsers/activityLog'

export class AccountActivityLogParser extends ActivityLogParser {
    static getLogDetailsCreated (activityLog, data) {
        return [
            { key: 'account', newValue: `${activityLog.properties.attributes.number} – ${activityLog.properties.attributes.name}` },
        ]
    }
}
